import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.jsx';
import './index.css';

/**
 * Application Entry Point
 * 
 * Initializes the React application with StrictMode for development checks.
 * Renders the main App component into the DOM root element.
 * 
 * @author SureCost Development Team
 * @version 1.0.0
 */

// Get the root DOM element
const rootElement = document.getElementById('root');

// Ensure root element exists
if (!rootElement) {
  throw new Error('Root element not found. Make sure there is a div with id="root" in your HTML.');
}

// Create React root and render the application
createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>
);